import React from 'react'
// hooks
import { useCurrentTable } from 'hooks/risks'

export const getMaxHeight = (group?: Record<string, number>) => {
  if (!group) {
    return 0
  }

  let max = 0

  for (const h of Object.values(group)) {
    if (h > max) {
      max = h
    }
  }

  return max
}

export const useRowOffset = ({ rowId, groupId }: { rowId?: string; groupId?: string }) => {
  const { rowHeights } = useCurrentTable()

  const offset = React.useMemo(() => {
    if (!groupId || !rowId) {
      return 0
    }

    const groupHeights = rowHeights[groupId]

    if (!groupHeights) {
      return 0
    }

    const highest = getMaxHeight(groupHeights)
    const myHeight = groupHeights[rowId] ?? 0

    return Math.max(0, highest - myHeight)
  }, [groupId, rowId, rowHeights])

  return offset
}
